import { ladderAccess, levelSomewhere, servicesHome } from '@church/data'
import { atLeast } from '@church/permissions'
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { SongsPills } from '../components/services/Discover.tsx'
import { PraiseChartsLinkResult } from '../components/services/PraiseCharts.tsx'
import { SongsPanel } from '../components/services/ServicesPanels.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { sectionCrumbs } from '../lib/services-crumbs.ts'

/** The song library. */
export const Route = createFileRoute('/_authed/_shell/services/_sections/songs/')({
  // Back from linking a PraiseCharts account.
  validateSearch: z.object({ praisecharts: z.enum(['linked', 'failed']).optional() }),
  // The library is Songs Viewer and up (13-ACCESS); anyone else sees the songs on their plans.
  beforeLoad: ({ context }) => {
    const held = ladderAccess(context.me)
    if (!atLeast(levelSomewhere(held, 'songs'), 'viewer'))
      throw redirect({ to: servicesHome(held), replace: true })
  },
  component: SongsScreen,
})

function SongsScreen() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  useBreadcrumbs(sectionCrumbs('Songs'))
  return (
    <div className="space-y-4">
      <SongsPills current="library" />
      {search.praisecharts && <PraiseChartsLinkResult outcome={search.praisecharts} />}
      <SongsPanel
        onOpen={(songId) => void navigate({ to: '/services/songs/$songId', params: { songId } })}
      />
    </div>
  )
}
